import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'
import { isCancellationError } from '@/lib/query/transient-network-error'

/**
 * Reports an error boundary error to Sentry on mount/update.
 * Shared across all error.tsx / global-error.tsx files to prevent drift.
 */
export function useSentryErrorBoundary(
  error: Error & { digest?: string },
): void {
  useEffect(() => {
    if (!isCancellationError(error)) {
      Sentry.captureException(error, { extra: { digest: error.digest } })
    }
  }, [error])
}
